import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

const PREFIXO = 'diagnostico/clientes';

export const buscarClientes = async (params) => {
  const url = `/${PREFIXO}/inatividade-vendas`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.clientes;
}

export const buscarSegmentos = async (params) => {
  const url = `/${PREFIXO}/inatividade-vendas/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.segmentos;
}

export const buscarFornecedores = async (params) => {
  const url = `/${PREFIXO}/inatividade-vendas/segmentos/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.fornecedores;
}

export const buscarProdutos = async (params) => {
  const url = `/${PREFIXO}/inatividade-vendas/segmentos/fornecedores/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}
